import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';
import { saveAs } from 'file-saver';

/**
 * @param {Object} page
 * @param {number} contestId
 */
export function downloadRatingsJSON(page, contestId) {
    notifier.deleteSenderNotifications(page);

    const url = `/contest/${contestId}/ratings`;
    HTTP.get(url)
    .then(response => {
      const contest = response.data.data;

      const contestStr = JSON.stringify(contest, null, 2);
      const blob = new Blob([contestStr], {type: 'application/json'});
  
      const fileName = `contest_${contestId}.json`;
      saveAs(blob, fileName);
    })
    .catch(err => {
      notifier.showError(err, {sender: page});
    });
}

/**
 * @param {Object} page
 * @param {number} contestId
 */
export function downloadRatingsCSV(page, contestId) {
  notifier.deleteSenderNotifications(page);

  const url = `/contest/${contestId}/ratings?format=csv`;
  HTTP.get(url)
  .then(response => {
    const contestData = response.data;

    const blob = new Blob([contestData]);

    const fileName = `contest_${contestId}.csv`;
    saveAs(blob, fileName);
  })
  .catch(err => {
    notifier.showError(err, {sender: page});
  });
}
